import { cn } from '@shadcn/lib/utils';
import { Loader2 } from 'lucide-react';
import { HTMLAttributes, useState } from 'react';
import styled from 'styled-components';

export function DataLoader({ className }: HTMLAttributes<HTMLDivElement>) {
  const [loaded, setLoaded] = useState(false);
  return (
    <>
      {!loaded && <div />}
      <SpinnerImg
        src="/ui/loading-spinner.svg"
        alt="loading spinner"
        className={cn(!loaded && 'invisible', className)}
        onLoad={() => setLoaded(true)}
      />
    </>
  );
}

const SpinnerImg = styled('img')`
  height: 50px;
  width: 50px;
  margin-top: 10px;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export function ActionLoader({ className }: HTMLAttributes<HTMLDivElement>) {
  return <Loader2 className={cn('h-4 w-4 animate-spin', className)} />;
}
